import React, { useEffect, useState } from "react";

import DashboardService from "../services/DashboardService";

import Navbar from "./layout/navbar";
import Sidebar from "./layout/sidebar";

import {
  Loading,
} from '../components';

import * as s from './privateAppContainer.module.css';

const PrivateAppContainer: React.FC<any> = (props) => {
  const [user, setUser] = useState({});
  const [error, setError] = useState(false);
  const [closedMenu, setClosedMenu] = useState(true);
  const [menu, setMenu] = useState([]);

  const [loading, setLoading] = useState(false);

  const modules = () => {
    setLoading(true);
    DashboardService.modules()
      .then((response) => {
        setLoading(false);
        setMenu(response);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  };

  useEffect(() => {
    modules();
    // eslint-disable-next-line
  }, []);

  const handleSelect = (profile: any) => {
    localStorage.setItem("profile", JSON.stringify(profile));
    // @ts-ignore
    modules(profile?.profileId);
    // dashboardBuyerAccess();
  };

  const handleLogout = () => {
    // dispatch(actions.logout());    
    window.history.back();
  };

  const handleSideMenu = (value: any) => {
    setClosedMenu(value);
  };

  let styles = closedMenu ? "" : "";

  return (
    <div className={ s.privateAppWrapper }>
      <Loading show={ loading }/>

      <Navbar
        user={user}
        handleLogout={handleLogout}
        handleSelect={handleSelect}
        error={error}
      />
      <Sidebar menuStorage={menu} handleSideMenu={handleSideMenu} />

      <div
        className={ s.privateAppWrapper }
        style={{ marginLeft: styles, transition: "all 0.3s linear" }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default PrivateAppContainer;